import { DialogTitle } from "@headlessui/react";

import { Trans, useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import Button from "@/components/buttons/Button";
import VerificationInput from "@/components/inputs/VerificationInput";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { usePostCheckCode } from "@/hooks/api/login.hooks";
import useModalRouter from "@/hooks/useModalRouter";
import { onError } from "@/utils/onError";
import { onSuccess } from "@/utils/onSuccess";

function ForgotPasswordCode() {
  const { t } = useTranslation();

  const { mutate } = usePostCheckCode();

  const [params] = useSearchParams();

  const { goBack, openModal } = useModalRouter();

  const accountId = params.get("account_id");
  const username = params.get("username");

  if (!accountId || !username) {
    return <></>;
  }

  const onSubmit = (code: string) => {
    mutate(
      { account_id: +accountId, code },
      {
        onSuccess(res) {
          onSuccess(res.message);
          openModal([MODAL_ROUTES.FORGOT_PASSWORD, MODAL_ROUTES.FORGOT_PASSWORD_SET_NEW], {
            code,
            account_id: accountId,
          });
        },
        onError,
      },
    );
  };

  return (
    <>
      <div className={"max-w-[27.5rem] text-center"}>
        <DialogTitle as={"h2"} className={"staff-modal__title"}>
          {t("auth.confirm-code")}
        </DialogTitle>

        {username && (
          <Trans
            i18nKey={"auth.confirm-login-message"}
            values={{ value: username }}
            components={{
              1: <span className={"text-orange-1"} />,
            }}
          />
        )}
      </div>
      <form className={"mt-8 flex flex-col items-center"}>
        <VerificationInput
          validChars={"0-9"}
          placeholder=""
          onComplete={onSubmit}
          classNames={{
            container:
              "h-20 w-[25.625rem] flex gap-[0.625rem] max-lg:gap-[0.313rem] max-lg:w-[20.313rem] max-lg:h-[4.375rem] responsive-transition",
            character: `bg-surface-container rounded-full h-20 flex items-center justify-center w-[3.75rem] hover:bg-red-1 text-on-primary max-lg:w-[3.125rem] max-lg:h-[4.375rem] responsive-transition outline outline-1 outline-transparent -outline-offset-1`,
            characterSelected: "pin-input bg-surface-container-high focus:outline-none border-none outline-on-primary",
            characterFilled: "bg-surface-container-high",
          }}
          error={false}
        />
        <Button className="mt-5" color={"white"} aria-label={t("Actions.cancel")} onClick={goBack}>
          {t("Actions.cancel")}
        </Button>
      </form>
    </>
  );
}

export default ForgotPasswordCode;
